import React from 'react'
import { useForm } from 'react-hook-form';

const ContactUs = () => {

    const {
        register,
        handleSubmit,
        formState: { errors },
    } = useForm();


    const onSubmit = (data) => {
    };

    return (
        <div className='contact-us'> 
            <div className='contact-us-container'>
                <div className='contact-us-form-desc'>
                    <div className='contact-left'>
                        <h3 className="contact-title">Ready to get
                            everything you need <br/>
                            to <span style={{color:"rgba(45, 118, 253, 1)"}}>hire better</span>?</h3>
                            <button>Request A Demo</button>
                    </div>
                    <div className='contact-right'>
                        <h4>Modern Recruiter newsletter</h4>
                        <p style={{width:"70%"}}>Our bi-weekly newsletter full of inspiration,
                            podcasts, trends and news.</p>
                        <form className="contact-us-form" onSubmit={handleSubmit(onSubmit)}>
                            <div className="contact-us-form-group">
                                <label htmlFor="email" className="contact-us-form-label">
                                    Email address <span style={{ color: "red" }}>*</span>
                                </label>
                                <input
                                    type="email"
                                    id="email"
                                    placeholder="Enter your email"
                                    className={`contat-us-form-input ${errors.email ? 'input-error' : ''}`}
                                    {...register("email", {
                                        required: "Email is required",
                                        pattern: { value: /^\S+@\S+\.\S+$/, message: "Invalid email format" },
                                    })}
                                />
                                {errors.email && <p className="error-message">{errors.email.message}</p>}
                            </div>

                            <button type="submit" className="contact-us-submit-button">
                                Subscribe
                            </button>
                        </form>
                        <p className='home-page-choose-language'>Choose your language</p>
                        <select className='language-select-home-page'>
                            <option value="English(US)">English(US)</option>
                            <option value="Hindi">Hindi</option>
                        </select>
                    </div>

                </div>
            </div>
        </div>
    )
}

export default ContactUs